module.exports = __webpack_public_path__ + "img/down-symbol.b5513dba.svg";